import { Injectable } from '@angular/core';

export class ActivityScope {
    constructor(public name: string, private completionCallback: (scope: ActivityScope) => void) {
    }

    public Complete(): void {
        this.completionCallback(this);
    }
}

// eslint-disable-next-line max-classes-per-file
@Injectable()
export class ActivityService {

    private activityScopes: ActivityScope[] = [];
    // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,id-blacklist,id-match
    private _isBusySinceAWhile = false;
    // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
    private _timer;

    public get isBusy(): boolean {
        return this.activityScopes.length > 0;
    }

    public get isBusySinceAWhile(): boolean {
        return this._isBusySinceAWhile;
    }

    public beginActivity(name: string): ActivityScope {
        const scope = new ActivityScope(name, this.endActivity);
        this.activityScopes.push(scope);

        // console.log('begin activity - count: ' + this.activityScopes.length + ' ; Name: ' + name);

        if (this._timer === undefined) {
            this._timer = setTimeout(() => {
                    if (this.activityScopes.length > 0) {
                        this._isBusySinceAWhile = true;
                    }
                }, 350);
        }
        return scope;
    }

    private endActivity = (scope: ActivityScope) => {
        const index = this.activityScopes.indexOf(scope, 0);
        if (index >= 0) {
            this.activityScopes.splice(index, 1);

            // console.log('end activity - count: ' + this.activityScopes.length + ' ; Name: ' + scope.name);
        }
        if (this.activityScopes.length === 0) {
            if (this._timer) {
                clearTimeout(this._timer);
                this._timer = undefined;
            }

            this._isBusySinceAWhile = false;
        }
    };
}
